import React from 'react';

import {
  Grid,
  Section,
  Stack,
  Picker,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  PlaylistRemoveIcon,
  RemoveCircleOutlineIcon,
} from '@gogame/components';
import {
  FormField,
  withForm,
  SidePageV2,
  FormErrorMessage,
  FormFieldArray,
} from '@gogame/form';
import { useQuery } from '@gogame/query';

import { BUSINESS_PARTNERS } from './constants';
import { validationSchema } from './schemas';

const defaultSchema = validationSchema.default();

const ShareForm = withForm({
  validationSchema,
  enableReinitialize: true,
})(({
  children,
  title,
  subTitle,
  source,
  loading,
  onClose,
  onExited,
  open,
  entityId,
}) => {
  const { data: businessPartners, isFetching } = useQuery(
    BUSINESS_PARTNERS,
    source
  );

  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
      size={'md'}
    >
      <SidePageV2.Title title={title} subTitle={subTitle} entityId={entityId} />
      <SidePageV2.Content>
        <FormFieldArray name={BUSINESS_PARTNERS}>
          {({ push, remove, form }) => {
            const value = form.values[BUSINESS_PARTNERS];
            const selectableAgencies = businessPartners?.filter(
              ({ id }) => !value?.includes(id)
            );
            const error = form.errors?.[BUSINESS_PARTNERS];

            return (
              <Section title={'Share to'}>
                <Stack
                  spacing={2}
                  {...(error ? { 'data-cy-has-error': true } : null)}
                >
                  <Grid item xs={12}>
                    <Picker
                      button={<Button add={true}>Business partner</Button>}
                      onChange={([{ id }]) => {
                        push(id);
                      }}
                      loading={isFetching}
                      options={selectableAgencies}
                    />
                  </Grid>
                  {value?.length ? (
                    <Grid item xs={12}>
                      <TableContainer>
                        <Table size={'small'}>
                          <TableHead>
                            <TableRow>
                              <TableCell size={'medium'}>Name</TableCell>
                              <TableCell
                                size={'medium'}
                                align={'right'}
                                width={40}
                                padding={'actions'}
                              >
                                <IconButton
                                  icon={<PlaylistRemoveIcon />}
                                  tooltip={'Remove all'}
                                  onClick={() =>
                                    form.setFieldValue(
                                      BUSINESS_PARTNERS,
                                      defaultSchema[BUSINESS_PARTNERS]
                                    )
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {value.map((id, i) => (
                              <TableRow key={id}>
                                <TableCell>
                                  <FormField.Const
                                    name={`${BUSINESS_PARTNERS}[${i}]`}
                                    options={businessPartners}
                                    padding={0}
                                  />
                                </TableCell>
                                <TableCell align={'right'}>
                                  <IconButton
                                    icon={<RemoveCircleOutlineIcon />}
                                    tooltip={'Remove'}
                                    onClick={() => remove(i)}
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  ) : null}
                  <FormErrorMessage name={BUSINESS_PARTNERS} />
                </Stack>
              </Section>
            );
          }}
        </FormFieldArray>
      </SidePageV2.Content>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
      {children}
    </SidePageV2>
  );
});

export default ShareForm;
